import * as React from 'react'
import { SVGProps } from 'react'

const ErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={10} fill="#D54238" />
    <path
      d="M17 8.007 15.993 7 12 10.993 8.007 7 7 8.007 10.993 12 7 15.993 8.007 17 12 13.007 15.993 17 17 15.993 13.007 12 17 8.007Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.5}
    />
  </svg>
)

export default ErrorIcon
